/* =========================================================================
   et-color-top.js - Ela Teila
   Pasirinkus kita SPALVA - naujas puslapis atsidaro nuo VIRSAUS,
   kad klientas matytu pilna pirma nuotrauka.

   Kraunama is snippets/et-scroll-keep.liquid.
   GRAZINIMAS: istrinti ta <script> eilute snippete.

   ---------------------------------------------------------------------
   KODEL REIKEJO TRIJU ZINGSNIU

   1) snippets/et-scroll-keep.liquid turejo scenariju, kuris atkurdavo
      buvusia slinkties vieta (sessionStorage 'etColorScroll'). Isimta.
   2) assets/et-color-prefetch.js paspaudus spalva ta reiksme irasydavo.
      Klausytojas isimtas.
   3) Bet tarpas vis tiek likdavo 1050px - nes tema naudoja "instant"
      navigacija (layout/theme.liquid body turi data-instant-allow-query-string):
      puslapis pakeiciamas vietoje, o slinktis lieka tokia pat.
      Todel cia po paspaudimo laukiam, kol pasikeicia adresas, ir
      nuleidziam i virsu.

   Matuota: pries pataisyma po spalvos pakeitimo scrollY=1050,
   po pataisymo 0.
   ========================================================================= */
(function () {
  function toTop() {
    try { window.scrollTo(0, 0); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('.et-color-switch__item') : null;
    if (!a) return;

    var from = location.pathname + location.search;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (location.pathname + location.search !== from) {
        toTop();
        setTimeout(toTop, 120);
        setTimeout(toTop, 400);
        clearInterval(timer);
      } else if (tries > 50) {
        clearInterval(timer);
      }
    }, 80);
  }, true);
})();
